import { IsOptional, IsBoolean, IsIn } from 'class-validator';

import { ExecutorFieldsDto } from './executor-fields.dto';

export class StartTaskDto extends ExecutorFieldsDto {
  @IsIn(['StartEvent'])
  type: 'StartEvent';

  @IsBoolean()
  @IsOptional()
  createForOthers?: boolean;

  @IsBoolean()
  @IsOptional()
  batchEnabled?: boolean;

  @IsBoolean()
  @IsOptional()
  noEmployee?: boolean;
}
